import { useMemo } from "react";
import { catcat as cc } from "cerulean";
import { entities } from "byzantine";
import styles from "./MerchantIcon.module.scss";

export interface MerchantIconProps {
  name: string;
  size?: "s" | "l";
}

const MerchantIcon = ({ name, size = "l" }: MerchantIconProps) => {
  const merchant = entities.merchants.useMerchant(name || "");
  const initials = useMemo(() => name.slice(0, 2).toUpperCase(), [name]);
  const containerClassName = useMemo(
    () =>
      cc(styles.container, {
        [styles.small]: size === "s",
        [styles.placeholder]: !merchant?.logo_url,
      }),
    [size]
  );

  if (merchant?.logo_url) {
    return (
      <div className={containerClassName}>
        <img src={merchant.logo_url} alt={name} className={styles.image} />
      </div>
    );
  }

  return (
    <div className={containerClassName}>
      <span className={styles.initials}>{initials}</span>
    </div>
  );
};

export default MerchantIcon;
